import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@/hooks';
import { useDeviceType } from '@/utils/device';
import { Sidebar, DesktopHeader } from '@/components/desktop';
import { MobileFooter } from '@/components/common';
import { ChevronLeft, Sun, Moon, User, Settings, Clock, Heart } from 'lucide-react';
import { useSiteSettings } from '@/contexts/settings-context';
import styles from './profile.module.css';

export const ProfilePage: React.FC = () => {
  const navigate = useNavigate();
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'mobile';
  const { theme, toggleTheme } = useTheme();
  const { features } = useSiteSettings();

  const menuItems = [
    { icon: <Clock size={20} />, label: '历史记录', desc: '查看最近玩过的游戏' },
    { icon: <Heart size={20} />, label: '我的收藏', desc: '收藏的游戏列表' },
    { icon: <Settings size={20} />, label: '设置', desc: '应用偏好设置' },
  ];

  // Mobile Layout
  if (isMobile) {
    return (
      <div className={styles.mobileContainer}>
        <header className={styles.mobileHeader}>
          <div className={styles.headerRow}>
            <button className={styles.backBtn} onClick={() => navigate(-1)} title="返回">
              <ChevronLeft size={22} />
            </button>
            <div className={styles.pageTitle}>个人中心</div>
            {features.darkMode && (
              <button className={styles.themeToggle} onClick={toggleTheme} title={theme === 'dark' ? '切换亮色模式' : '切换暗色模式'}>
                {theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
              </button>
            )}
          </div>
        </header>

        <main className={styles.mobileMain}>
          <div className={styles.userCard}>
            <div className={styles.avatar}>
              <User size={32} />
            </div>
            <div className={styles.userInfo}>
              <h2 className={styles.userName}>游客</h2>
              <p className={styles.userDesc}>登录后可同步游戏数据</p>
            </div>
          </div>

          <div className={styles.menuList}>
            {menuItems.map((item) => (
              <div key={item.label} className={styles.menuItem}>
                <div className={styles.menuIcon}>{item.icon}</div>
                <div className={styles.menuText}>
                  <span className={styles.menuLabel}>{item.label}</span>
                  <span className={styles.menuDesc}>{item.desc}</span>
                </div>
                <span className={styles.menuBadge}>🚧 开发中</span>
              </div>
            ))}
          </div>
        </main>
        <MobileFooter />
      </div>
    );
  }

  // Desktop Layout
  return (
    <div className={styles.desktopContainer}>
      <Sidebar activePath="/profile" />

      <div className={styles.desktopContent}>
        <DesktopHeader showSearch={false} />

        <main className={styles.desktopMain}>
          <div className={styles.profileHeader}>
            <h1 className={styles.profileTitle}>个人中心</h1>
          </div>

          <div className={styles.userCard}>
            <div className={styles.avatar}>
              <User size={40} />
            </div>
            <div className={styles.userInfo}>
              <h2 className={styles.userName}>游客</h2>
              <p className={styles.userDesc}>登录后可同步游戏数据</p>
            </div>
          </div>

          <div className={styles.menuList}>
            {menuItems.map((item) => (
              <div key={item.label} className={styles.menuItem}>
                <div className={styles.menuIcon}>{item.icon}</div>
                <div className={styles.menuText}>
                  <span className={styles.menuLabel}>{item.label}</span>
                  <span className={styles.menuDesc}>{item.desc}</span>
                </div>
                <span className={styles.menuBadge}>🚧 开发中</span>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
};

export default ProfilePage;
